module.exports = __webpack_public_path__ + "static/img/jpeg.39b040b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chat/images/chat_files/jpeg.png
// module id = IUnh
// module chunks = 1